import React from 'react'
import {Redirect} from 'react-router-dom'
import {FuseUtils} from '@fuse/index'
import {LoginPageConfig} from 'main/content/login/LoginPageConfig'
import {RegisterPageConfig} from 'main/content/login/RegisterPageConfig'
import {ForgotPasswordPageConfig} from 'main/content/login/ForgotPasswordPageConfig'
import {ResetPasswordPageConfig} from 'main/content/login/ResetPasswordPageConfig'
import {EmailVerificationPageConfig} from 'main/content/login/EmailVerificationPageConfig'
import {AuthPageConfig} from 'main/content/login/AuthPageConfig'
import {ProjectsPageConfig} from 'main/content/projects/ProjectsPageConfig'
import {NewProjectPageConfig} from 'main/content/projects/NewProjectPageConfig'
import {projectConfig} from 'main/content/project/projectConfig'

const routeConfigs = [
  ...projectConfig,
  LoginPageConfig,
  RegisterPageConfig,
  ForgotPasswordPageConfig,
  ResetPasswordPageConfig,
  EmailVerificationPageConfig,
  AuthPageConfig,
  ProjectsPageConfig,
  NewProjectPageConfig,
]

export const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
  {
    path: '/',
    component: () => <Redirect to="/login" />,
  },
]



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseRoutesConfig.js